export default __webpack_public_path__ + "static/media/logo.9a9c8cb4.png";